import { useRef } from "react";

import { getErrorMessage } from "@/core/services";
import { useToast } from "@/ds";
import { useChaveIdempotencia } from "@/shared/hooks";

type AvisoDeSucesso = string | { resumo: string; detalhe?: string };

interface AtivarDiretoOpcoes<Alvo extends object> {
  enviar: (alvo: Alvo, idempotencyKey: string) => Promise<unknown>;
  sucesso: (alvo: Alvo) => AvisoDeSucesso;
  aoConcluir: () => void;
  erroPadrao: string;
}

export function useAtivarDireto<Alvo extends object>({
  enviar,
  sucesso,
  aoConcluir,
  erroPadrao,
}: AtivarDiretoOpcoes<Alvo>) {
  const toast = useToast();
  const { comChave } = useChaveIdempotencia();
  const emCurso = useRef(false);

  return async (alvo: Alvo) => {
    if (emCurso.current) return;
    emCurso.current = true;
    try {
      await comChave({ alvo: "id" in alvo ? alvo.id : alvo, situacao: "ATIVA" }, (idempotencyKey) =>
        enviar(alvo, idempotencyKey),
      );
      const aviso = sucesso(alvo);
      if (typeof aviso === "string") toast.success(aviso);
      else toast.success(aviso.resumo, aviso.detalhe);
      aoConcluir();
    } catch (erro) {
      toast.error(getErrorMessage(erro) || erroPadrao);
    } finally {
      emCurso.current = false;
    }
  };
}
